/* eslint-disable */
// @generated by protobuf-ts 2.9.1 with parameter generate_dependencies,long_type_string,optimize_speed,eslint_disable,ts_nocheck
// @generated from protobuf file "pkg/proto/response.proto" (package "response", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * this is intended to be more of a Toast message for the front end
 * errors on the server will be communicated in the signature of the rpc service return value
 *
 * @generated from protobuf message response.Info
 */
export interface Info {
    /**
     * How the UI should present the result: SUCCESS, WARNING or ERROR.
     * Unexpected failures usually come back as gRPC errors instead; each RPC
     * says when it sets ERROR.
     *
     * @generated from protobuf field: response.Status status = 1;
     */
    status: Status;
    /**
     * Short text the UI can show to the user, such as in a toast. Can be
     * empty.
     *
     * @generated from protobuf field: string message = 2;
     */
    message: string;
    /**
     * Trace ID to quote to support. Set only on some non-SUCCESS responses.
     *
     * @generated from protobuf field: optional string trace_id = 3;
     */
    traceId?: string;
}
/**
 * @generated from protobuf message response.Pagination
 */
export interface Pagination {
    /**
     * Number of results that match the query across all pages, not only this
     * page.
     *
     * @generated from protobuf field: uint32 total_results = 1;
     */
    totalResults: number;
    /**
     * True when more results follow this page.
     *
     * @generated from protobuf field: bool has_more_results = 2;
     */
    hasMoreResults: boolean;
    /**
     * Number of this page.
     *
     * @generated from protobuf field: uint32 current_page_number = 3;
     */
    currentPageNumber: number;
}
/**
 * these statuses are intended to be consumed by the UI and displayed to users
 *
 * @generated from protobuf enum response.Status
 */
export enum Status {
    /**
     * response was successful
     *
     * @generated from protobuf enum value: SUCCESS = 0;
     */
    SUCCESS = 0,
    /**
     * information to the user that something potentially negative has occurred with their request
     *
     * @generated from protobuf enum value: WARNING = 1;
     */
    WARNING = 1,
    /**
     * a message to display to the user indicating something that didn't pass validation, or another error that they can handle
     *
     * @generated from protobuf enum value: ERROR = 2;
     */
    ERROR = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class Info$Type extends MessageType<Info> {
    constructor() {
        super("response.Info", [
            { no: 1, name: "status", kind: "enum", T: () => ["response.Status", Status] },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "trace_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Info>): Info {
        const message = { status: 0, message: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Info>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Info): Info {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* response.Status status */ 1:
                    message.status = reader.int32();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                case /* optional string trace_id */ 3:
                    message.traceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Info, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* response.Status status = 1; */
        if (message.status !== 0)
            writer.tag(1, WireType.Varint).int32(message.status);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        /* optional string trace_id = 3; */
        if (message.traceId !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.traceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message response.Info
 */
export const Info = new Info$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Pagination$Type extends MessageType<Pagination> {
    constructor() {
        super("response.Pagination", [
            { no: 1, name: "total_results", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "has_more_results", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "current_page_number", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Pagination>): Pagination {
        const message = { totalResults: 0, hasMoreResults: false, currentPageNumber: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Pagination>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Pagination): Pagination {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 total_results */ 1:
                    message.totalResults = reader.uint32();
                    break;
                case /* bool has_more_results */ 2:
                    message.hasMoreResults = reader.bool();
                    break;
                case /* uint32 current_page_number */ 3:
                    message.currentPageNumber = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Pagination, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 total_results = 1; */
        if (message.totalResults !== 0)
            writer.tag(1, WireType.Varint).uint32(message.totalResults);
        /* bool has_more_results = 2; */
        if (message.hasMoreResults !== false)
            writer.tag(2, WireType.Varint).bool(message.hasMoreResults);
        /* uint32 current_page_number = 3; */
        if (message.currentPageNumber !== 0)
            writer.tag(3, WireType.Varint).uint32(message.currentPageNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message response.Pagination
 */
export const Pagination = new Pagination$Type();
